import { CHECK_IF_ONLINE, IsOnlineActionTypes } from './types';

export function checkIfOnline(): IsOnlineActionTypes {
	return {
		type: CHECK_IF_ONLINE,
	};
}
